<template>
  <div class="terminal-h5">
    <div class="w1200 pt96 pb48 center">
      <div class="lz-title1 mb8">微信H5店铺</div>
      <div class="lz-desc1 T6 EC3 mb64">给每个公众号都装上强大的移动课堂</div>
      <div class="lz-img">
        <img :src="require('@/assets/images/terminalPic1.png')" alt="" />
      </div>
    </div>
    <div class="lz-modules1 w1200 pt96">
      <div class="lz-title1">
        一分钟帮您<br
          v-if="$store.state.sceneClassName === 'app'"
        />在微信公众号内搭建移动课堂
      </div>
      <div class="module-box pt64 pb64 row-reverse">
        <div class="module-text">
          <div class="title EC2 T4 mb24">可无缝嵌入公众号任何位置</div>
          <div class="module-text-item mb16">
            <div class="desc EC3 T6 lz-desc2">
              首页菜单栏、图文内嵌、欢迎语、关键词回复推送等位置均可展现课堂入口，方便用户快速找到
            </div>
          </div>
        </div>
        <div class="module-img lz-img">
          <img
            v-if="$store.state.sceneClassName === 'app'"
            :src="require('@/assets/images/terminalPic2_app.png')"
            alt=""
          />
          <img
            v-else
            :src="require('@/assets/images/terminalPic2.jpg')"
            alt=""
          />
        </div>
      </div>
      <div class="module-box module-box-s pt64 pb64">
        <div class="module-text">
          <div class="title EC2 T4 mb24">
            一键转发<br v-if="$store.state.sceneClassName === 'app'" />
            让课堂在微信中自由传播
          </div>
          <div class="module-text-item mb16">
            <div class="desc EC3 T6 lz-desc2">
              首页菜单栏、图文内嵌、欢迎语、关键词回复推送等位置均可展现课堂入口，方便用户快速找到
            </div>
          </div>
        </div>
        <div class="module-img lz-img">
          <img
            v-if="$store.state.sceneClassName === 'app'"
            :src="require('@/assets/images/terminalPic3_app.png')"
            alt=""
          />
          <img
            v-else
            :src="require('@/assets/images/terminalPic3.jpg')"
            alt=""
          />
        </div>
      </div>
    </div>
    <div v-if="$store.state.sceneClassName !== 'app'" class="w1200 pt96 pb64">
      <div class="lz-title1 mb64">丰富付费形式及教学管理体系</div>
      <ul class="capacity">
        <li class="function-item center">
          <div class="icon">
            <i class="EC1 T2 iconfont iconicon_classroom"></i>
          </div>
          <h3 class="name mb8 T6 EC2">多种课堂</h3>
        </li>
        <li class="function-item center">
          <div class="icon">
            <i class="EC1 T2 iconfont iconicon_Marketing"></i>
          </div>
          <h3 class="name mb8 T6 EC2">营销推广</h3>
        </li>
        <li class="function-item center">
          <div class="icon">
            <i class="EC1 T2 iconfont iconicon_Student"></i>
          </div>
          <h3 class="name mb8 T6 EC2">学员管理</h3>
        </li>
        <li class="function-item center">
          <div class="icon">
            <i class="EC1 T2 iconfont iconicon_data"></i>
          </div>
          <h3 class="name mb8 T6 EC2">数据分析</h3>
        </li>
        <li class="function-item center">
          <div class="icon">
            <i class="EC1 T2 iconfont iconicon_community"></i>
          </div>
          <h3 class="name mb8 T6 EC2">社群运营</h3>
        </li>
        <li class="function-item center">
          <div class="icon">
            <i class="EC1 T2 iconfont iconicon_Finance"></i>
          </div>
          <h3 class="name mb8 T6 EC2">财务管理</h3>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'terminal',
  data() {
    return {};
  },
  components: {},
  mounted() {
  },
  methods: {

  }
};
</script>

<style lang="scss">
.app .terminal-h5 {
  .lz-desc1 {
    margin-top: 0.16rem;
  }
  .lz-modules1 {
    background: #f6f9ff;
  }
  .module-box {
    display: block;
    padding-bottom: 1.28rem;
    .title {
      margin-top: 0.48rem;
      margin-bottom: 0;
      padding: 0;
      font-size: 0.32rem !important;
      line-height: 1.3;
      font-weight: 600;
    }
    .module-text-item {
      margin-bottom: 0;
      width: auto;
    }
    .lz-desc2 {
      margin-top: 0.16rem;
    }
  }
  .module-box-s {
    padding: 0.8rem 0 1.28rem;
    background: #ffffff;
    .module-text-item .lz-desc2 {
      padding: 0 0.76rem;
      color: #999;
    }
  }
}
</style>
